import React, { Component } from "react";
import { times, invert } from "lodash";
import classnames from "classnames";
import runes from "../constants/runes";

const dotDiameter = 5;
const padSideLength = 40;
const padPadding = 0;
const lineColor = "#fff";

function generateDotPositions(sideLength, dotDiameter) {
  const positions = times(
    3,
    i => padPadding / 2 + i * (sideLength / 2 - dotDiameter / 2)
  );
  const final = [];
  times(3, i => {
    times(3, j => {
      final.push([positions[j], positions[i]]);
    });
  });
  return final;
}

const positions = generateDotPositions(padSideLength, dotDiameter);

function findRune(name) {
  const invertedOpen = invert(runes.open);
  const invertedClosed = invert(runes.closed);
  if (invertedOpen[name]) {
    return invertedOpen[name].split("").map(num => parseInt(num, 10));
  }
  if (invertedClosed[name]) {
    const nums = invertedClosed[name].split("").map(num => parseInt(num, 10));
    return [...nums, nums[0]]; // close the path
  }
}

class Rune extends Component {
  componentDidMount() {
    this.ctx.scale(2, 2);

    if (!this.props.name) return;
    const runePositions = findRune(this.props.name);
    if (!runePositions) return;

    for (let i = 0; i < runePositions.length - 1; i++) {
      const fromDot = this.getDotCenter(runePositions[i]);
      const toDot = this.getDotCenter(runePositions[i + 1]);

      this.drawLine({
        color: lineColor,
        size: 2,
        startX: fromDot.x,
        startY: fromDot.y,
        endX: toDot.x,
        endY: toDot.y
      });
    }
  }
  drawLine = line => {
    if (!this.ctx) return;

    this.ctx.strokeStyle = line.color;
    this.ctx.lineWidth = line.size;
    this.ctx.lineCap = "round";
    this.ctx.beginPath();
    this.ctx.moveTo(line.startX, line.startY);
    this.ctx.lineTo(line.endX, line.endY);
    this.ctx.stroke();
  };
  getDotCenter = dotNum => {
    const [x, y] = positions[dotNum - 1];
    return { x: x + dotDiameter / 2, y: y + dotDiameter / 2 };
  };
  render() {
    return (
      <div
        className="rune"
        style={{ transform: `scale(${this.props.scale || 1})` }}
      >
        <div
          className={classnames(
            "rune-dots",
            this.props.shouldHideDots && "hide-dots"
          )}
          style={{
            width: padSideLength,
            height: padSideLength
          }}
        >
          {times(3, i => (
            <div key={i} className="rune-row">
              {times(3, j => {
                return (
                  <div
                    key={j}
                    style={{
                      width: dotDiameter,
                      height: dotDiameter,
                      borderRadius: dotDiameter
                    }}
                    className={classnames("dot")}
                  />
                );
              })}
            </div>
          ))}
        </div>
        <canvas
          className="rune-canvas"
          width={(padSideLength + padPadding) * 2}
          height={(padSideLength + padPadding) * 2}
          style={{
            display: "block",
            height: padSideLength + padPadding,
            width: padSideLength + padPadding
          }}
          ref={canvas => {
            if (canvas) {
              this.canvas = canvas;
              this.ctx = canvas.getContext("2d");
            }
          }}
        />
      </div>
    );
  }
}

export default Rune;



// WEBPACK FOOTER //
// ./src/components/Rune.js